/*
  Harmélys — Aucune taille présélectionnée sur les fiches produit et les packs.

  Shopify sélectionne toujours une variante en interne (la première disponible). On la garde côté technique
  (prix, stock, formulaire), mais visuellement aucune taille n'apparaît choisie tant que la cliente n'a pas cliqué.
  Tant qu'une taille manque, l'ajout au panier est bloqué et un message invite à la choisir.

  Ne s'applique que si la page a été ouverte sans variante précise dans l'adresse (?variant=...).
*/
(() => {
  if (window.hmVariantChoiceLoaded) return;
  window.hmVariantChoiceLoaded = true;

  const MESSAGE = 'Sélectionnez votre taille';

  // form-id -> Set des positions d'options choisies par la cliente
  const pickedByForm = new Map();

  const getFieldsets = (picker) => Array.from(picker.querySelectorAll('fieldset.variant-picker__option[data-hm-choice]'));

  const positionOf = (fieldset, index) => {
    const input = fieldset.querySelector('input[data-option-position]');
    return input ? input.getAttribute('data-option-position') : String(index + 1);
  };

  const apply = (picker) => {
    const formId = picker.getAttribute('form-id');
    if (!formId) return;

    if (!pickedByForm.has(formId)) {
      if (!picker.hasAttribute('data-hm-require-choice')) return;
      pickedByForm.set(formId, new Set());
    }

    const picked = pickedByForm.get(formId);

    getFieldsets(picker).forEach((fieldset, index) => {
      const isPicked = picked.has(positionOf(fieldset, index));
      fieldset.classList.toggle('hm-unpicked', !isPicked);
      if (isPicked) fieldset.classList.remove('hm-needs-choice');
    });
  };

  const applyAll = () => document.querySelectorAll('variant-picker').forEach(apply);

  // Un clic sur une taille compte comme un choix, même si c'est la taille déjà sélectionnée en interne
  document.addEventListener('click', (event) => {
    const input = event.target.closest?.('input[data-option-position]');
    if (!input) return;

    const formId = input.getAttribute('form');
    const picked = pickedByForm.get(formId);
    if (!picked) return;

    picked.add(input.getAttribute('data-option-position'));
    document.querySelectorAll(`variant-picker[form-id="${formId}"]`).forEach(apply);
  }, true);

  // Bloque l'ajout au panier tant qu'une taille manque (bouton principal et barre d'achat collante)
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.id || !pickedByForm.has(form.id)) return;

    const picker = document.querySelector(`variant-picker[form-id="${form.id}"]`);
    if (!picker) return;

    const missing = getFieldsets(picker).filter((fieldset) => fieldset.classList.contains('hm-unpicked'));
    if (missing.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    missing.forEach((fieldset) => {
      fieldset.classList.add('hm-needs-choice');
      fieldset.setAttribute('data-hm-message', MESSAGE);
    });

    missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  // Le thème remplace le sélecteur à chaque changement de taille : on réapplique l'état
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; applyAll(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  applyAll();
})();
